// extracted by mini-css-extract-plugin
module.exports = {"getDelivery":"styles_getDelivery__29GMj","text":"styles_text__13ADX","btn":"styles_btn__3sdOZ"};